import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styles from './header.scss';

class LivestreamSubheader extends React.PureComponent {
    render() {
        return (
            <div className={styles.tocHeaderWrapper}>
                <div className={styles.statusSection}>
                    <div className={styles.statusText}>
                        <h1>{this.props.test.title}</h1>
                    </div>
                </div>
            </div>
        );
    }
}

LivestreamSubheader.propTypes = {
    test: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        test: state.assessment,
    };
}

const LivestreamSubheaderContainer = connect(mapStateToProps)(LivestreamSubheader);
export default LivestreamSubheaderContainer;
